define(function (require) {
    const tpl = require('civicsViews/share_url/templates/t_itv_url.hbs');

    return Marionette.ItemView.extend({
        template: tpl,
        ui: {
            copyURLButton: '.url-copy-button',
            shareURLField: '.share-url-field .input-text'
        },
        events: {
            'click @ui.copyURLButton': 'copyURLLink',
        },
        initialize: function (options) {
            this.config = options.config;
            this.portletName = options.portletName; // target portletName to find its corresponding labels
            this.URLPath = options.URLPath;
            this.URLParams = options.URLParams;
            this.usesFullURLPath = options.usesFullURLPath;

            //setup the labels
            if (this.portletName && this.portletName.length > 0) {
                var localizationKey = this.portletName.toUpperCase();

                this.commonLabel = {
                    'url_field': i18n.t('CIVICS.' + localizationKey + '.SHARE_URL.URL_FIELD'),
                    'copy_text': i18n.t('CIVICS.' + localizationKey + '.SHARE_URL.COPY_STRING'),
                    'copied_text': i18n.t('CIVICS.' + localizationKey + '.SHARE_URL.COPIED_STRING')
                }
            }

            // Generate URL
            if (this.URLPath != undefined) {
                var urlParams = this.URLParams ? this.URLParams : '';
                var targetPath = this.URLPath.urlPath(urlParams);
                if(this.usesFullURLPath) {
                  this.shareUrl = this.URLPath;
                } else {
                  this.shareUrl = window.location.origin.concat(targetPath);

                }
            }
        },
        onShow: function () {

        },
        onRender: function () {
            this.ui.shareURLField.val(this.shareUrl);
            this.ui.shareURLField[0].setAttribute('readonly', true);
        },
        copyURLLink: function () {
          var iCopy = document.createElement("input");
          iCopy.setAttribute("value", this.shareUrl);
          document.body.appendChild(iCopy);
          iCopy.select();
          document.execCommand("copy");
          document.body.removeChild(iCopy);

            // this.ui.shareURLField.select();
            // document.execCommand("copy");
          this.ui.copyURLButton.text(this.commonLabel.copied_text);
        },
        templateHelpers: function () {
            var self = this;
            return {
                url_field: self.commonLabel.url_field,
                copy_text: self.commonLabel.copy_text
            };
        }
    });
});
